module.exports = __webpack_public_path__ + "img/placeholder_mom_1x.dc6cc9a7.png";